export default __webpack_public_path__ + "static/media/narrateImage.e72c8b49.png";